import { NodeViewContent, NodeViewWrapper, type ReactNodeViewProps, useEditorState } from "@tiptap/react";
import { getHost } from "../host";

export function CalloutView({ node, editor, updateAttributes }: ReactNodeViewProps) {
  const editable = useEditorState({ editor, selector: ({ editor: e }) => e.isEditable });
  const kind = node.attrs.kind === "warning" ? "warning" : "note";
  const title = (node.attrs.title as string | null) ?? null;
  const labels = getHost(editor).labels;
  const fallback = kind === "warning" ? labels.warning : labels.note;
  const update = (attrs: Record<string, unknown>) => {
    if (editor.isEditable) updateAttributes(attrs);
  };

  return (
    <NodeViewWrapper as="aside" className="kd-callout" data-kind={kind}>
      {editable ? (
        <div className="kd-callout__tools" contentEditable={false}>
          <div role="radiogroup" aria-label="Callout kind" className="flex gap-1">
            {(["note", "warning"] as const).map((k) => (
              // biome-ignore lint/a11y/useSemanticElements: card-style radio rendered as a button
              <button
                key={k}
                type="button"
                role="radio"
                aria-checked={kind === k}
                className="kd-tool"
                onClick={() => update({ kind: k })}
              >
                {k === "note" ? "Note" : "Warning"}
              </button>
            ))}
          </div>
          <input
            aria-label="Callout title"
            placeholder={`Title (default “${fallback}”)`}
            value={title ?? ""}
            onChange={(e) => update({ title: e.target.value.trim() === "" ? null : e.target.value })}
          />
        </div>
      ) : null}
      <div className="kd-callout__body">
        <span className="kd-callout__label" contentEditable={false}>{`${title ?? fallback}:`}</span>
        <NodeViewContent className="kd-callout__content" />
      </div>
    </NodeViewWrapper>
  );
}
